import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { capitalize } from '../../helpers/strings';
import { Icon } from '../Icon/Icon';
import * as styles from './IconButton.module.scss';
export var IconButtonTestID;
(function (IconButtonTestID) {
    IconButtonTestID["IconButton"] = "IconButtonTestID.IconButton";
})(IconButtonTestID || (IconButtonTestID = {}));
const IconButtonSizes = {
    small: {
        iconSize: 8,
    },
    medium: {
        iconSize: 10,
    },
    large: {
        iconSize: 20,
    },
};
const Name = 'IconButton';
export const IconButton = ({ icon, title, disabled = false, variant = 'secondary', size = 'medium', className, testID = IconButtonTestID.IconButton, onClick, }) => {
    const containerStyle = [
        styles.iconButton,
        styles[`container${capitalize(variant)}`],
        styles[`content${capitalize(variant)}`],
        styles[`size${capitalize(size)}`],
    ];
    return (_jsx("button", { className: clsx(containerStyle, className), type: "button", "data-testid": testID, "data-component": Name, title: title, disabled: disabled, onClick: onClick, children: _jsx(Icon, { name: icon, size: IconButtonSizes[size].iconSize, color: "inherit", "aria-hidden": "true" }) }));
};
